<h2 class="default-dialog-header font-weight-normal" mat-dialog-title>
	<span fxFlex> Select Group </span>
	<span fxFlex="10" fxLayoutAlign="end end">
		<mat-icon (click)="closeDialog({})" class="primary-light-color cursor-pointer">
			close
		</mat-icon>
	</span>
</h2>
<mat-divider></mat-divider>

<mat-dialog-content class="default-dialog-content">
	<div class="m-t-1">
		<mat-radio-group [(ngModel)]="selectedGroupId" fxLayout="column" fxLayoutGap="1rem">
			<mat-radio-button
				*ngFor="let group of projectGroupList"
				[value]="group.id"
				color="primary"
				class="m-b-0-5"
			>
				{{ group.name }}&nbsp;(Contact:&nbsp;{{
					(group.delayByMinutes && group.delayByMinutes + ' Minutes') || 'Immediately'
				}})
			</mat-radio-button>
		</mat-radio-group>
	</div>
</mat-dialog-content>
<mat-divider></mat-divider>

<mat-dialog-actions class="default-dialog-action">
	<div fxFlex fxLayoutAlign="end end" fxLayoutGap="1rem">
		<button
			(click)="groupSelected()"
			color="primary"
			mat-raised-button
			[disabled]="!selectedGroupId"
		>
			Select
		</button>
	</div>
</mat-dialog-actions>
